import * as Yup from "yup";

export const schemaChangePassword = Yup.object().shape({
  newPassword: Yup.string()
    .min(6, "Minimum characters is 6")
    .required("New password is a required field"),
  changePassword: Yup.string()
    .min(6, "Minimum characters is 6")
    .required("Re-type new password is a required field"),
});
